



























































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { GrantData } from "@/entities";

const namespace: string = "grant";

@Component({
    components: {
        DateComponent,
        WorkflowButtons,
        ValidationMessageComponent
    }
})
export default class GrantAgreement extends Vue {
    @Action("getGrantData", { namespace }) getGrantData: any;
    @Action("saveGrantData", { namespace }) saveGrantData: any;
    @State(namespace) grant!: GrantData;
    @Prop() readOnly: boolean;
    @Prop() modelWrapper: any;
    @Prop() grantAgreementDate: string;
    @Prop() primaryProgramOfficerId: any;
    @Prop() isConfidential: any;
    @Prop() grantId: any;

    agreeDateKey: number = 0;
    // items = [];
    // selectors = [
    //     { "text": "Yes", "value": 1 },
    //     { "text": "No", "value": 0 }
    // ]

    // mounted() {
    //     this.$services.grant.ActiveUsersByUserType()
    //     .then((resp: any) => {
    //         if (resp.Result == 'OK') {
    //             this.items = resp.Record;
    //         }
    //     })
    // }

    /** computed property workflow items */
    get workFlowItems() {
        return this.grant.selectedGrant.WorkflowInfo || {}
    }

    /** workflow pre-action */
    preValidation() {
        return this.saveGrantData({
            data: this.grant.grantData,
            id: this.grant.selectedGrant.GrantId,
            hideNotification: true
        }).then(() => {  
            this.getGrantData(this.grant.selectedGrant.GrantId);           
        });
    }

    /** show validations */
    showValidation(msgs: any) {
        this.grant.validationMessages = msgs;
        this.grant.showValidationDilog = true;
    }

    validationMessageClosed() {
        this.grant.showValidationDilog = false;
        this.grant.validationMessages = [];
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }

    validationMessageClicked(msg: any) {
        this.grant.showValidationDilog = false;
        this.grant.validationMessages = [];
        
        if(msg.SectionKey) {
            this.$router.push({
                name: "grantAgreement",
                params: { grantId: this.grantId, section: msg.SectionKey },    
                hash: `#${msg.SectionKey}`
            });
        } else {
            this.$router.push({
                name: "grantAgreement",
                params: { grantId: this.grantId, section: msg.SectionKey }
            });
        }  
    }
}
